import { Grid, Box, useTheme, CardContent, Typography, Paper } from "@mui/material";
import { IActiveModal } from "src/pages/Admin/AdminWindow";

interface ICrewTravelHomeProps {
  setTabValue: any;
  hasDashboard: boolean;
}

export const CrewTravelHome = (props: ICrewTravelHomeProps): JSX.Element => {
  const { setTabValue, hasDashboard } = props;
  const theme = useTheme();
  const paperStyle = {
    border: `1px solid ${theme.palette.primary.dark}`,
    padding: 1,
    transition: "background-color 350ms",
    minHeight: 80,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      transition: "background-color 700ms",
    },
  };

  const tabList = [
    {
      title: "Dashboard",
      desc: "Internal version of the hotel portal",
      order: 2,
      tabValue: "HotelDashboardTab",
      key: 1,
    },
    {
      title: "Bookings",
      desc: "Crew Travel Bookings",
      order: 3,
      tabValue: "BookingsTab",
      key: 2,
    },
    {
      title: "Booking Errors",
      desc: "View Booking Issues",
      order: 4,
      tabValue: "BookingErrorsTab",
      key: 3,
    },
    {
      title: "Hotels",
      desc: "Manage Hotel List",
      order: 5,
      tabValue: "HotelsTab",
      key: 4,
    },
  ];

  return (
    <CardContent>
      <Grid container spacing={1} columns={10}>
        {tabList
          .sort((a, b) => {
            if (a.order > b.order) {
              return 1;
            } else {
              return -1;
            }
          })
          .map((tab, tabIdx) => {
            if (tab.tabValue === "HotelDashboardTab" && hasDashboard !== true) {
              return <Box key={tabIdx}></Box>;
            }
            return (
              <Grid item xs={2} key={tabIdx} onClick={(e) => setTabValue(e, tab.tabValue)}>
                <Paper elevation={4} sx={paperStyle}>
                  <Typography sx={{ fontWeight: 900 }}>{tab.title}</Typography>
                  <Typography sx={{ fontSize: "0.8rem" }}>{tab.desc}</Typography>
                </Paper>
              </Grid>
            );
          })}
      </Grid>
    </CardContent>
  );
};

export default CrewTravelHome;
